import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Box, Flex } from 'components/Layout/Layout';

import Input from 'components/Input/Input';
import LoginView from 'components/LoginView/LoginView';
import Button from 'components/Button/Button';
import P from 'components/P/P';
import Ahref from 'components/Ahref/Ahref';
import { ROUTE_FORGOT, ROUTE_SIGNUP } from 'RouteList';

import messages from './messages';
import { isEmailValid } from '../../utils/email';
import { ROUTE_SET_PASSWORD } from '../../RouteList';
import { useStores } from '../../store/useStores';

function Login() {
  const intl = useIntl();
  const { authStore, routing } = useStores();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add('blue');
    return () => {
      document.body.classList.remove('blue');
    };
  }, []);

  const handleSubmit = useCallback(
    async event => {
      event.preventDefault();

      setError(null);
      setUsernameError(false);
      setPasswordError(false);

      const response = await authStore.login(username.toLowerCase(), password);
      if (response?.error) {
        if (response.newPasswordRequired) {
          routing.push(ROUTE_SET_PASSWORD);
        } else {
          setError(response.error.message);
          setUsernameError(true);
          setPasswordError(true);
        }
      }
    },
    [authStore, password, routing, username]
  );

  const onSignupClick = useCallback(() => {
    routing.push(ROUTE_SIGNUP);
  }, [routing]);

  const onForgotClick = useCallback(() => {
    routing.push(ROUTE_FORGOT);
  }, [routing]);

  const title = intl.formatMessage(messages.loginTitle);
  const message = intl.formatMessage(messages.loginMessage);

  return (
    <LoginView title={title} message={message}>
      <form onSubmit={handleSubmit}>
        {error && (
          <Box mb={10}>
            <P danger>{error}</P>
          </Box>
        )}
        <Box mb={3}>
          <Input
            placeholder={intl.formatMessage(messages.loginUsername)}
            onChange={e => setUsername(e.target.value)}
            value={username}
            type="text"
            error={usernameError}
          />
        </Box>
        <Box mb={3}>
          <Input
            onChange={e => setPassword(e.target.value)}
            placeholder={intl.formatMessage(messages.loginPassword)}
            value={password}
            type="password"
            error={passwordError}
          />
        </Box>
        <Flex flexWrap="wrap">
          <Box width={[1, 1, 1 / 2]} mb={[3, 3, 0]}>
            <Button
              disabled={!username || !password || !isEmailValid(username)}
              secondary
            >
              <FormattedMessage {...messages.loginSubmitButton} />
            </Button>
          </Box>
          <Flex
            width={[1, 1, 1 / 2]}
            justifyContent="space-between"
            flexWrap="wrap"
            alignItems="center"
          >
            <Box width={1}>
              <Ahref onClick={onSignupClick}>
                <FormattedMessage {...messages.loginSignup} />
              </Ahref>
            </Box>
            <Box width={1}>
              <Ahref onClick={onForgotClick}>
                <FormattedMessage {...messages.loginPasswordForgotten} />
              </Ahref>
            </Box>
          </Flex>
        </Flex>
      </form>
    </LoginView>
  );
}

export default observer(Login);
